module.exports = __webpack_public_path__ + "img/koa.50775278.jpg";